exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeviceUsageAnalysisPage .MultivalueDisplay > div {\n  text-align: center;\n  width: 33.3%;\n}\n\n.DeviceUsageAnalysisPage .MultivalueDisplay .report {\n  border: none;\n}\n\n.DeviceUsageAnalysisPage .TableReport {\n  min-height: 300px;\n}\n\n.DeviceUsageAnalysisPage .MultivalueDisplay.report {\n  border-bottom-width: 1px;\n  border-left-width: 1px;\n  border-top-width: 1px;\n}\n\n/*will be removed once applied in common method*/\n\n.DeviceUsageAnalysisPage .pageContent {\n  padding: 30px 30px 0;\n}", ""]);

// exports
